import React from 'react';

const DataDrivenWarning = () => {
  return (
    <p className="warning-feedback position-absolute">Data-driven matching is supported only for equals matcher</p>
  );
};

export default DataDrivenWarning;
